
import { Action } from '@ngrx/store';
import { UserAuthedDTO } from 'src/app/models/DTO/UserAuthedDTO';
import {userAccount} from 'src/app/models/users';
export enum UserActionTypes {
  ACTION_LOGOUT = '[User] Logout',
  ACTION_LOGIN = '[User] Login'
}

export class UserLogout implements Action {
  readonly type = UserActionTypes.ACTION_LOGOUT;
}

export class UserLogin implements Action {
  readonly type = UserActionTypes.ACTION_LOGIN;
  constructor(public payload: { user: UserAuthedDTO }) {}
}
